import moment from 'moment';

export default {
  namespaced: true,

  state: {
    canDragToEmptyLesson: false,
    lessonTypePopup: false,
    switchViewMonth: 0,
    dragLessons: {},
    days: [],
    teachers: [],
    totalPage: 0,
    viewCount: 0,
    totalCount: 0,
    teachersArray: [],
    lessonTypeId: undefined,
    breakTypeId: undefined,
    currentWeekday: new Date().getDay(),
    dayRecordsPanel: false,
    dayPopupShow: false,
    dayPopupRequestToLessonShow: false,
    dayPopupRequestToEmptyLessonShow: false,
    draggedStudent: {},
    dayPopupEmptyLesson: false,
    dayPopupDaySlot: undefined,
    lessonSubjects: [],
    lessonTypes: [],
    scheduleLessons: [],
    exceptionDays: [],
    studentStatuses: [],
    students: [],
    monthLessonsCount: {},
    lessons: [],
    reportReasons: [],
    calendarEvents: [],
    teacherSkills: [],
    classLevels: [],
    requestsToLesson: [],
    checkTime: true
  },

  getters: {
    getRequestsToLesson(state) {
      return state.requestsToLesson;
    },
    getDayRecordPanel(state) {
      return state.dayRecordsPanel;
    },
    enabledLessons(state) {
      return state.lessons.filter(l => l.is_active);
    },
    disabledLessons(state) {
      return state.lessons.filter(l => !l.is_active);
    },
    enabledScheduleLessons(state) {
      return state.scheduleLessons.filter(l => l.is_active);
    },
    disabledScheduleLessons(state) {
      return state.scheduleLessons.filter(l => !l.is_active);
    },

    day(state, getters) {
      return date => {
        if (!_.isDate(date)) {
          return;
        }

        const dateShort = `${date.getFullYear()}-${(date.getMonth() + 1)
          .toString()
          .padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;

        const weekday = date.getDay();
        const day = state.days.find(d => d.weekday === weekday);

        if (!day) {
          return;
        }

        const exceptionDay = state.exceptionDays.find(
          e => e.date === dateShort
        );

        const result = {
          date,
          dateShort,
          weekday,
          day,
          exceptionDay,
          slots: [],
          active: true
        };

        if (exceptionDay && exceptionDay.active) {
          result.active = false;
        }

        if (!day.active) {
          result.active = false;
        }

        result.slots = day.slots.map(s => getters.daySlot(result, s));

        return result;
      };
    },
    daySlots(state) {
      return (day, date, teacher) => {
        const results = [];

        for (const slot of day.slots) {
          const dateShort = `${date.getFullYear()}-${(date.getMonth() + 1)
            .toString()
            .padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;

          const result = {
            day,
            date,
            dateShort,
            teacher,
            slot,
            type_id: slot.type_id,
            disabled: false,
            free: false
          };

          result.exceptionDay = state.exceptionDays.find(
            e => e.date === dateShort
          );

          result.disabled = !!(
            result.exceptionDay && result.exceptionDay.active
          );

          if (result.type_id === state.lessonTypeId) {
            result.scheduleLesson = state.scheduleLessons.find(
              l =>
                l.teacher_id === teacher.id &&
                l.days &&
                l.days.find(
                  lD =>
                    lD.start.slice(0, 5) === slot.start &&
                    lD.finish.slice(0, 5) === slot.finish &&
                    day.weekday === lD.weekday
                )
            );

            if (result.scheduleLesson) {
              result.disabled = !result.scheduleLesson.is_active;
            }
            result.lesson = state.lessons.find(
              l =>
                l.teacher_id === teacher.id &&
                l.start.slice(0, 5) === slot.start &&
                l.finish.slice(0, 5) === slot.finish &&
                l.date === dateShort
            );

            if (result.lesson) {
              result.disabled = !result.lesson.is_active;
            }

            if (!result.lesson && !result.scheduleLesson) {
              result.free = true;
            }
          } else if (result.type_id === state.breakTypeId) {
          }

          results.push(result);
        }
        return results;
      };
    },
    daySlot() {
      return (day, slot) => {
        const result = {
          active: true,
          slot
        };

        const exceptionDay = day.exceptionDay;

        if (exceptionDay) {
          const exceptionDaySlot = exceptionDay.slots.find(
            s =>
              s.start.slice(0, 5) === slot.start &&
              s.finish.slice(0, 5) === slot.finish &&
              s.type_id === slot.type_id
          );
          result.exceptionDay = exceptionDay;
          result.exceptionDaySlot = exceptionDaySlot;

          if (exceptionDaySlot) {
            result.active = !exceptionDaySlot.active;
          }
        }

        return result;
      };
    }
  },

  mutations: {
    SET_TOTAL_PAGE(state, value) {
      state.totalPage = value;
    },
    SET_TOTAL_COUNT(state, value) {
      state.totalCount = value;
    },
    SET_VIEW_COUNT(state, value) {
      state.viewCount = value;
    },
    SET_CHECK_TIME(state, value) {
      state.checkTime = value;
    },
    SET_SWITCHER(state, value) {
      state.switchViewMonth = state.switchViewMonth === 1 ? 0 : 1;
    },
    SET(state, [name, value]) {
      state[name] = value;
    },
    SET_REQUESTS_TO_LESSON(state, data) {
      state.requestsToLesson = data;
    },
    SET_LESSON_TYPE_ID(state, value) {
      state.lessonTypeId = value;
    },
    SET_BREAK_TYPE_ID(state, value) {
      state.breakTypeId = value;
    },
    SET_DAYS(state, value) {
      state.days = value;
    },
    SET_TEACHERS(state, value) {
      state.teachers = value;
    },
    SET_TEACHERS_ARRAY(state, value) {
      state.teachersArray = value;
    },
    SET_WEEKDAY(state, value) {
      if (_.isNumber(value) && value >= 0 && value < 8) {
        state.currentWeekday = value;
      }
    },
    SET_DAY_RECORD_PANEL_TOGGLE(state, value) {
      state.dayRecordsPanel = value;
    },
    DAY_POPUP_SHOW(state) {
      state.dayPopupShow = true;
    },
    DAY_POPUP_HIDE(state) {
      state.dayPopupShow = false;
    },
    SET_DAY_POPUP_DAY_SLOT(state, value) {
      state.dayPopupDaySlot = value;
    },
    SET_DAY_POPUP_TYPE(state, value) {
      state.dayPopupType =
        value === 'scheduleLesson' ? 'scheduleLesson' : 'lesson';
    },
    SET_POPUP_REQ_TO_LESSON_SHOW(state) {
      state.dayPopupRequestToLessonShow = true;
    },
    SET_POPUP_REQ_TO_LESSON_HIDE(state) {
      state.dayPopupRequestToLessonShow = false;
    },
    SET_DRAGGED_STUDENT(state, data) {
      state.draggedStudent = { ...data };
    },
    SET_POPUP_REQ_TO_EMPTY_LESSON_SHOW(state) {
      state.dayPopupRequestToEmptyLessonShow = true;
    },
    SET_POPUP_REQ_TO_EMPTY_LESSON_HIDE(state) {
      state.dayPopupRequestToEmptyLessonShow = false;
    },
    TOGGLE_POPUP_EMPTY_LESSON(state) {
      state.dayPopupEmptyLesson = !state.dayPopupEmptyLesson;
    },
    SET_LESSON_SUBJECTS(state, value) {
      state.lessonSubjects = value;
    },
    SET_LESSON_TYPES(state, value) {
      state.lessonTypes = value;
    },
    SET_SCHEDULE_LESSONS(state, value) {
      state.scheduleLessons = value;
    },
    SET_EXCEPTION_DAYS(state, value) {
      state.exceptionDays = value;
    },
    SET_STUDENT_STATUSES(state, value) {
      state.studentStatuses = value;
    },
    SET_STUDENTS(state, value) {
      state.students = [...state.students, ...value];
    },
    SET_STUDENTS_FILTER(state, value) {
      state.students = value;
    },
    SET_MONTH_LESSONS_COUNT(state, value) {
      state.monthLessonsCount = Object.assign(value, state.monthLessonsCount);
    },
    SET_LESSONS(state, value) {
      state.lessons = value;
    },
    SET_REPORT_REASONS(state, value) {
      state.reportReasons = value;
    },
    SET_CALENDAR_EVENTS(state, value) {
      state.calendarEvents = value;
    },
    SET_TEACHER_SKILLS(state, value) {
      state.teacherSkills = value;
    },
    SET_CLASS_LEVELS(state, value) {
      state.classLevels = value;
    }
  },

  actions: {
    async fetchTypes({ commit }, params) {
      const res = await this.$service.retrieve(
        this.$services.studyCenter.timeSlotTypes,
        { params }
      );
      const types = res.data;
      commit('SET_LESSON_TYPE_ID', types.find(t => t.slug === 'lesson')?.id);
      commit('SET_BREAK_TYPE_ID', types.find(t => t.slug === 'pause')?.id);
    },
    async fetchDays({ rootState, state, commit, dispatch }, params = {}) {
      params.campus_id = rootState.settings.selectedCampus.id;

      // const res = await this.$service.retrieve(
      //   this.$services.studyCenter.timeSlotTemplates,
      //   { params }
      // );
      const res = await this.$service.retrieve(this.$services.common.teachers, {
        params
      });
      const types = res.data;

      // await dispatch('fetchScheduleLessons', params);
      // await dispatch('fetchLessons', params);
      await dispatch('fetchExceptionDays', params);
      await dispatch('fetchClassLevels', params);

      commit('SET_DAYS', res.data);

      const d = res.data;
      const daysSlots = d.slots.map(s => {
        s.start = s.start.slice(0, 5);
        s.finish = s.finish.slice(0, 5);
        s.time = s.start + ' - ' + s.finish;
        s.editing = false;
        return s;
      });
      daysSlots.sort((a, b) => a.order - b.order);
      let i = 1;
      daysSlots.forEach(s => {
        if (s.type_id === state.lessonTypeId) {
          s.title = 'שיעור ' + i++;
        } else if (s.type_id === state.breakTypeId) {
          s.title = 'הפסקה';
        }
      });

      const daysTeachers = d.teachers.map(t => {
        t.skills = t.study_center_skills.map(s => {
          const classLevel = state.classLevels.find(
            c => c.id === s.pivot.class_level_id
          );
          return s.name + ' ' + (classLevel?.name || '');
        });

        return t;
      });
      //   d.slots.sort((a, b) => a.order - b.order);
      //
      //   let i = 1;
      //
      //   d.slots.forEach(s => {
      //     if (s.type_id === state.lessonTypeId) {
      //       s.title = 'שיעור ' + i++;
      //     } else if (s.type_id === state.breakTypeId) {
      //       s.title = 'הפסקה';
      //     }
      //   });
      //
      //   d.teachers = d.teachers.map(t => {
      //     t.skills = t.study_center_skills.map(s => {
      //       const classLevel = state.classLevels.find(
      //         c => c.id === s.pivot.class_level_id
      //       );
      //       return s.name + ' ' + (classLevel?.name || '');
      //     });
      //
      //     return t;
      //   });
      //
      //   return d;
      // });
      // commit('SET_DAYS', { slots: daysSlots, teachers: daysTeachers });
    },
    async fetchTeachers({ commit }, params) {
      const res = await this.$service.retrieve(this.$services.common.teachers, {
        params
      });
      commit('SET_TEACHERS', res.data);
    },
    async fetchTeachersArray({ commit }, params) {
      const res = await this.$service.retrieve(
        this.$services.common.teachers1,
        {
          params
        }
      );
      commit('SET_TEACHERS_ARRAY', res.data);
    },
    async fetchLessonSubjects({ commit }, params) {
      const res = await this.$service.retrieve(
        this.$services.studyCenter.lessonSubjects,
        { params }
      );
      commit(
        'SET_LESSON_SUBJECTS',
        res.data.map(d => ({ ...d, text: d.name }))
      );
    },
    async fetchLessonTypes({ commit }, params) {
      const res = await this.$service.retrieve(
        this.$services.studyCenter.lessonTypes,
        { params }
      );
      commit(
        'SET_LESSON_TYPES',
        res.data.map(d => ({ ...d, text: d.name }))
      );
    },
    async fetchScheduleLessons({ commit }, params) {
      const res = await this.$service.retrieve(
        this.$services.studyCenter.scheduleLessons,
        { params }
      );
      commit('SET_SCHEDULE_LESSONS', res.data);
    },
    async fetchExceptionDays({ commit }, params) {
      const res = await this.$service.retrieve(
        this.$services.studyCenter.exceptionDays,
        { params }
      );

      const exceptionDays = res.data.map(l => {
        const date = new Date(l.date);
        l.date = `${date.getFullYear()}-${(date.getMonth() + 1)
          .toString()
          .padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;

        return l;
      });

      commit('SET_EXCEPTION_DAYS', exceptionDays);
    },
    async fetchStudentStatuses({ commit }, params) {
      const res = await this.$service.retrieve(
        this.$services.studyCenter.lessonUserStatuses,
        { params }
      );
      commit('SET_STUDENT_STATUSES', res.data);
    },
    async fetchStudents({ commit, rootState }, params) {
      const res = await this.$service.retrieve(
        this.$services.studentList.students,
        {
          params
        }
      );
      const students = res.data.data.map(s => ({
        ...s.user,
        id: s.user.id,
        user_id: s.user.id,
        student_id: s.id,
        class_name: s.student_class?.class_name,
        group_name: s.group?.name
      }));

      commit('SET_STUDENTS', students);
      commit('SET_TOTAL_PAGE', res.data.meta.last_page);
      commit('SET_VIEW_COUNT', res.data.meta.to);
      commit('SET_TOTAL_COUNT', res.data.meta.total);
    },
    async fetchStudentsFilter({ commit, rootState }, params) {
      const res = await this.$service.retrieve(
        this.$services.studentList.students,
        {
          params
        }
      );
      const students = res.data.data.map(s => ({
        ...s.user,
        id: s.user.id,
        user_id: s.user.id,
        student_id: s.id,
        class_name: s.student_class?.class_name,
        group_name: s.group?.name
      }));

      commit('SET_STUDENTS_FILTER', students);
      commit('SET_TOTAL_PAGE', res.data.meta.last_page);
      commit('SET_VIEW_COUNT', res.data.meta.to);
      commit('SET_TOTAL_COUNT', res.data.meta.total);
    },
    async fetchMonthLessonsCount({ commit }, date = new Date()) {
      const start = new Date(
        date.getTime() - (date.getDate() - 1) * 24 * 60 * 60 * 1000
      );
      const end = new Date(start.getTime());
      start.setTime(start.getTime() - start.getDay() * 24 * 60 * 60 * 1000);
      end.setMonth(end.getMonth() + 1);
      end.setTime(end.getTime() + (7 - end.getDay()) * 24 * 60 * 60 * 1000);

      const res = await this.$service.retrieve(
        this.$services.studyCenter.monthLessonsCount,
        {
          params: {
            start: parseInt(start.getTime() / 1000),
            end: parseInt(end.getTime() / 1000)
          }
        }
      );

      commit('SET_MONTH_LESSONS_COUNT', res.data);
    },
    async fetchLessons({ commit }, params) {
      const { data } = await this.$service.retrieve(
        this.$services.studyCenter.dayLessons,
        {
          params
        }
      );
      const lessons = [];
      data.teachers.map(teacher => {
        if (teacher.lessons) {
          teacher.lessons.map(l => {
            const date = new Date(l.date.replace('Z', '').substr(0, 10));
            l.date = `${date.getFullYear()}-${(date.getMonth() + 1)
              .toString()
              .padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
            lessons.push(l);
          });
        }
      });

      commit('SET_LESSONS', lessons);
    },
    async fetchReportReasons({ commit }, params) {
      const res = await this.$service.retrieve(
        this.$services.reports.reportReasons,
        { params }
      );
      commit(
        'SET_REPORT_REASONS',
        res.data.map(r => ({
          id: r.id,
          text: r.name
        }))
      );
    },
    async fetchCalendarEvents({ commit }, params) {
      const res = await this.$service.retrieve(
        this.$services.studyCenter.calendarEvents,
        { params }
      );

      commit('SET_CALENDAR_EVENTS', res.data);
    },
    async fetchTeacherSkills({ commit }, params) {
      const res = await this.$service.retrieve(
        this.$services.studyCenter.teacherSkills,
        { params }
      );
      commit('SET_TEACHER_SKILLS', res.data);
    },
    async fetchClassLevels({ commit }, params) {
      const res = await this.$service.retrieve(
        this.$services.studyCenter.classLevels,
        { params }
      );
      commit('SET_CLASS_LEVELS', res.data);
    },
    // async fetchRequestsToLesson({ commit }, params) {   // запрос по регистрации учеников на урок
    //   const res = await this.$service.retrieve(
    //     this.$services.studyCenter.requestToLesson,
    //     { params }
    //   );

    //   commit('SET_REQUESTS_TO_LESSON', res.data);
    // },

    async disableOneLesson({ dispatch }, daySlot) {
      const categoryUrl = location.pathname.split('/')[2];
      const date = new Date(daySlot.dateShort);
      const until = date.setDate(date.getDate() + 1);
      const { data } = await this.$service.create(
        this.$services.studyCenter.blockTemplates,
        {
          params: {
            from_date: daySlot.dateShort,
            until_date: moment(until).format('YYYY-MM-DD'),
            teacher_id: daySlot.teacher.id,
            campus_id: daySlot.teacher.campus_id,
            category_url: categoryUrl,
            start: daySlot.slot.start,
            finish: daySlot.slot.finish,
            is_active: 0
          }
        }
      );
      return data;
    },
    async disableAllLessons({ dispatch }, daySlot) {
      const categoryUrl = location.pathname.split('/')[2];
      const { data } = await this.$service.create(
        this.$services.studyCenter.blockTemplates,
        {
          params: {
            from_date: daySlot.dateShort,
            until_date: daySlot.until_date,
            teacher_id: daySlot.teacher.id,
            campus_id: daySlot.teacher.campus_id,
            category_url: categoryUrl,
            start: daySlot.slot.start,
            finish: daySlot.slot.finish,
            is_active: 0
          }
        }
      );
      return data;
    },

    async deleteStudentForever({ dispatch }, params) {
      try {
        const { data } = await this.$service.create(
          this.$services.studyCenter.deleteStudentForever,
          {
            params: {
              from_date: params.from_date
            },
            urlParams: {
              scheduleLessonId: params.scheduleLessonId,
              studentId: params.studentId
            }
          }
        );
        return data;
      } catch (e) {
        console.error(e.message);
      }
    },

    async enableOneLesson({ dispatch }, daySlot) {},
    async enableAllLessons({ dispatch }, daySlot) {},

    async disableDay({ rootState, dispatch }, day) {
      const exceptionDay = day.exceptionDay;

      if (exceptionDay) {
        await this.$service.update(this.$services.studyCenter.exceptionDayId, {
          urlParams: {
            day: exceptionDay.id
          },
          data: {
            active: 1,
            campus_id: rootState.settings.selectedCampus.id
          },
          partial: false
        });
      } else {
        await this.$service.create(this.$services.studyCenter.exceptionDays, {
          data: {
            date: day.dateShort,
            active: 1,
            campus_id: rootState.settings.selectedCampus.id
          }
        });
      }

      await dispatch('fetchDays');
    },
    async enableDay({ dispatch }, day) {
      const exceptionDay = day.exceptionDay;

      if (exceptionDay) {
        await this.$service.update(this.$services.studyCenter.exceptionDayId, {
          urlParams: {
            day: exceptionDay.id
          },
          data: {
            active: 0
          },
          partial: false
        });
      } else {
        await this.$service.update(
          this.$services.studyCenter.timeSlotTemplateId,
          {
            urlParams: {
              template: day.day.id
            },
            data: {
              active: 1
            },
            partial: false
          }
        );
      }

      await dispatch('fetchDays');
    },

    async disableDaySlot({ rootState, dispatch }, { daySlot, day }) {
      const exceptionDay = day.exceptionDay;
      const slot = daySlot.slot;

      if (exceptionDay) {
        const exceptionSlots = _.cloneDeep(exceptionDay.slots);
        const exceptionSlotIndex = exceptionSlots.findIndex(
          s =>
            s.start.slice(0, 5) === slot.start &&
            s.finish.slice(0, 5) === slot.finish &&
            s.type_id === slot.type_id
        );
        const exceptionSlot = exceptionSlots[exceptionSlotIndex];

        if (exceptionSlot) {
          exceptionSlot.active = 1;
        } else {
          exceptionSlots.push({
            start: slot.start,
            finish: slot.finish,
            type_id: slot.type_id,
            active: 1
          });
        }

        await this.$service.update(this.$services.studyCenter.exceptionDayId, {
          urlParams: {
            day: exceptionDay.id
          },
          data: {
            slots: exceptionSlots,
            campus_id: rootState.settings.selectedCampus.id
          },
          partial: false
        });
      } else {
        const exceptionSlot = {
          start: slot.start,
          finish: slot.finish,
          type_id: slot.type_id,
          active: 1
        };

        const exceptionSlots = [exceptionSlot];

        await this.$service.create(this.$services.studyCenter.exceptionDays, {
          data: {
            campus_id: rootState.settings.selectedCampus.id,
            date: day.dateShort,
            active: 0,
            slots: exceptionSlots
          },
          partial: false
        });
      }

      await dispatch('fetchDays');
    },
    async enableDaySlot({ dispatch }, { daySlot, day }) {
      const exceptionDay = day.exceptionDay;
      const slot = daySlot.slot;

      if (exceptionDay) {
        const exceptionSlots = _.cloneDeep(exceptionDay.slots);
        const exceptionSlotIndex = exceptionSlots.findIndex(
          s =>
            s.start.slice(0, 5) === slot.start &&
            s.finish.slice(0, 5) === slot.finish &&
            s.type_id === slot.type_id
        );
        const exceptionSlot = exceptionSlots[exceptionSlotIndex];

        if (exceptionSlot) {
          exceptionSlot.active = 0;

          await this.$service.update(
            this.$services.studyCenter.exceptionDayId,
            {
              urlParams: {
                day: exceptionDay.id
              },
              data: {
                slots: exceptionSlots
              },
              partial: false
            }
          );

          await dispatch('fetchDays');
        }
      }
    },

    async deleteLesson({ dispatch }, daySlot) {
      if (daySlot.lesson) {
        await this.$service.delete(this.$services.studyCenter.lessonId, {
          urlParams: {
            lesson: daySlot.lesson.id
          }
        });
      }
    },
    async deleteScheduleLesson({ dispatch }, daySlot) {
      if (daySlot.scheduleLesson) {
        await this.$service.delete(
          this.$services.studyCenter.scheduleLessonId,
          {
            urlParams: {
              lesson: daySlot.scheduleLesson.id
            }
          }
        );
      }
    }
  }
};
